export function IconAddMetadata() {
    return (
        <svg width="12" height="12" viewBox="0 0 12 12">
            <path fill="currentColor" d="M1.25 2.5c0-.69.56-1.25 1.25-1.25h2a.75.75 0 0 1 0 1.5H2.75v6.5H4.5a.75.75 0 0 1 0 1.5h-2c-.69 0-1.25-.56-1.25-1.25v-7zm5.5-.5a.75.75 0 0 1 .75-.75h2c.69 0 1.25.56 1.25 1.25v7c0 .69-.56 1.25-1.25 1.25h-2a.75.75 0 0 1 0-1.5h1.75v-6.5H7.5A.75.75 0 0 1 6.75 2zM6.6 4.5a.6.6 0 0 0-1.2 0v.9h-.9a.6.6 0 0 0 0 1.2h.9v.9a.6.6 0 0 0 1.2 0v-.9h.9a.6.6 0 0 0 0-1.2h-.9v-.9z"/>
        </svg>
    );
}
